import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CloseButtonProps } from 'react-toastify/dist/components';
import { getIcon } from '../Icons';
import './Toast.scss';

export const options = {
  autoClose: 3000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: false,
  rtl: false,
  pauseOnVisibilityChange: false,
  draggable: false,
  pauseOnHover: false,
};

const CloseSnackbarButton = ({ closeToast }: CloseButtonProps) => (
  <span className="close-icon" onClick={closeToast}>
    {getIcon('IconClose')}
  </span>
);

export function OpenSuccessToast(message) {
  toast.dismiss();
  toast.info(message, {
    position: 'bottom-center',
    className: 'custom-toast info',
    closeButton: (props) => <CloseSnackbarButton {...props} />,
    icon: () => getIcon('IconCircleInfo'),
    ...options,
  });
}
